<template>
  <div :class="['floating-window', { fullScreen: isFullScreen }]">
    <auth-img
      class="ai-btn"
      @click="toggleWindow"
      src="@/assets/img/ai/ai-btn.png"
      alt="AI"
      :class="{ expanded: isExpanded }"
    />

    <div :class="['window-content', { fullScreen: isFullScreen, expanded: isExpanded }]">
      <div class="header">
        <a-row>
          <a-col :span="12">
            <auth-img class="ai" src="@/assets/img/ai/ai.png" />
            <auth-img class="logo" src="@/assets/img/ai/logo.png" />
          </a-col>
          <a-col :span="12" class="handler-icon">
            <auth-img
              class="expend"
              :src="isFullScreen ? ReduceImg : ExpendImg"
              @click="isFullScreen = !isFullScreen"
            />
            <auth-img class="close" src="@/assets/img/chat/close_white.png" @click="toggleWindow" />
          </a-col>
        </a-row>
      </div>
      <div class="ai-chat">
        <div class="search-header">
          <Department class="depart" @changeDepartment="changeDepartment" />
          <a-input-search
            class="ai-search"
            v-model:value="bussBar.keyword"
            placeholder="请输入你的问题～"
            enter-button="搜索"
            size="large"
            @search="onSearch"
            allowClear
            @input="handleInput"
          />
        </div>
        <div class="content-wrap">
          <div class="tips" v-show="showTips">
            <auth-img src="@/assets/img/ai/tips.png" />
            如未搜索到答案，可尝试换种问法搜索
          </div>
          <div
            ref="associateListRef"
            :class="[
              { show: bussBar.showQuestion && bussBar.keyword, showPadding: showTips },
              'search-content',
              'content'
            ]"
          >
            <div
              class="item"
              v-for="item in associateList"
              :key="item.id"
              @click="getQuestionkey(item)"
              v-html="item.regQuestion"
            ></div>
          </div>
          <div :class="[{ show: bussBar.showAnswer }, 'answer-wrap', 'content']">
            <a-tabs v-model:activeKey="activeKey" class="category" @change="changeTab">
              <a-tab-pane key="inner" tab="内部问答知识库">
                <Answer
                  :loading="loading"
                  :answer="bussBar.innerAnswer"
                  :question_type="0"
                  :question_id="bussBar.questionID"
                  @exportMessage="exportMessage"
                  ref="innerAnswerWrapRef"
                />
              </a-tab-pane>
              <a-tab-pane key="third" tab="AI大模型回答">
                <Answer
                  :loading="loading"
                  :answer="bussBar.thirdAnswer"
                  :question_type="1"
                  :question_id="bussBar.aiQuestionID"
                  @exportMessage="exportMessage"
                  :showRefresh="true"
                  @getAnswer="getAnswer"
                  ref="thirdAnswerWrapRef"
                />
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineExpose, reactive, onMounted, onBeforeUnmount } from 'vue'
import Department from './compnents/department'
import Answer from './compnents/answer.vue'
import { defaultBussBar } from './config'
import { throttle } from 'lodash-es'
import { readStreamData, requstMethod } from './useStream'
import { message } from 'ant-design-vue'
import ReduceImg from '@/assets/img/ai/reduce.png'
import ExpendImg from '@/assets/img/ai/expend.png'
import Queue from './Queue'
//弹窗状态
const isExpanded = ref(false)
const isFullScreen = ref(false)
const associateList = ref([])
const activeKey = ref('inner')
const loading = ref(false)
const showTips = ref(false)
const associateListRef = ref(null)
const innerAnswerWrapRef = ref(null)
const thirdAnswerWrapRef = ref(null)
const bussBar = reactive({ ...defaultBussBar })
const toggleWindow = () => {
  isExpanded.value = !isExpanded.value
  isFullScreen.value = false
}
// 关闭弹窗
const closeWindow = () => {
  isExpanded.value = false
}

// 切换科室
const changeDepartment = (init, item) => {
  bussBar.department = item.id
  !init && onSearch()
}
const handleInput = e => {
  const value = e.target.value
  bussBar.keyword = value?.trim() ?? ''
  onChange()
}
const onChange = throttle(() => {
  const val = bussBar.keyword
  bussBar.showQuestion = true
  bussBar.showAnswer = false
  bussBar.innerAnswer = ''
  bussBar.thirdAnswer = ''
  bussBar.questionID = undefined
  bussBar.aiQuestionID = undefined
  associateListRef.value.scrollTop = 0
  showTips.value = false
  if (!val) {
    associateList.value = []
  } else {
    const params = {
      url: 'doctor_assistant.html',
      method: 'post',
      query: {
        m: 'question_completion',
        p: {
          prompt: val,
          limit_count: 999,
          department_id: bussBar.department
        }
      }
    }
    requstMethod(params).then(res => {
      const data = res.data || []
      if (data?.length) {
        const regExp = new RegExp(val, 'g')
        associateList.value = data.map(item => {
          const question = item.question
          item.regQuestion = question.replace(regExp, `<span style="color: #808080;">${val}</span>`)
          return item
        })
      } else {
        associateList.value = []
      }
    })
  }
}, 500)

const onSearch = () => {
  const { keyword, questionID } = bussBar
  if (!keyword) return message.warn('请输入关键字')
  let item = {}
  // 没有点击联想的时候，自动给他匹配联想（精准匹配）
  if (!questionID) {
    item = associateList.value.find(item => item.question === keyword) ?? {}
    item.id ? getQuestionkey(item) : getAnswer()
  } else {
    getInnerAnswer()
  }
}
// 内部精确搜索
const getInnerAnswer = () => {
  showTips.value = false
  bussBar.showQuestion = false
  bussBar.showAnswer = true
  bussBar.innerAnswer = ''
  bussBar.thirdAnswer = ''
  associateList.value = []
  activeKey.value = 'inner'
  loading.value = true
  const params = {
    url: 'doctor_assistant.html',
    method: 'post',
    query: { m: 'question_query', p: { id: bussBar.questionID, department_id: bussBar.department } }
  }
  requstMethod(params)
    .then(res => {
      loading.value = false
      const data = res.data
      bussBar.innerAnswer = data?.[0]?.human_answer ?? ''
    })
    .catch(() => {
      loading.value = false
      bussBar.innerAnswer = ''
    })
}
//第三方AI搜索
const getAnswer = (refresh = false) => {
  showTips.value = false
  bussBar.showQuestion = false
  bussBar.showAnswer = true
  bussBar.innerAnswer = ''
  bussBar.thirdAnswer = ''
  associateList.value = []
  activeKey.value = 'third'
  loading.value = true
  abortResponse()
  handleStreamData()
}
// 存储上一次的请求，当重新请求一次接口的时候，通过这个对象可以进行中断
let lastController = null
const handleStreamData = (refresh = false) => {
  const onConsume = text => {
    bussBar.thirdAnswer += text
  }
  const answerQueue = new Queue(onConsume)
  const params = {
    url: 'doctor_assistant.html',
    method: 'post',
    query: {
      m: 'question_answer_v2',
      p: {
        prompt: bussBar.keyword,
        department_id: bussBar.department,
        use_rag: false,
        streaming: true,
        refresh
      }
    }
  }
  const onCreated = controller => {
    lastController = controller
    loading.value = false
    thirdAnswerWrapRef.value.onDispatch(true)
    answerQueue.printing()
  }
  const onPatch = text => {
    answerQueue.enqueue(text)
  }
  const onDone = params => {
    const { question_id } = params
    bussBar.aiQuestionID = question_id
    answerQueue.done()
    thirdAnswerWrapRef.value.onDispatch(false)
  }
  const onFail = () => {
    bussBar.thirdAnswer = ''
    bussBar.aiQuestionID = null
    loading.value = false
    answerQueue.clear()
    thirdAnswerWrapRef.value.onDispatch(false)
  }
  const param = {
    params,
    onCreated,
    onPatch,
    onDone,
    onFail
  }
  readStreamData(param)
}
const abortResponse = () => {
  lastController?.abort()
}
// 拿到题目id
const getQuestionkey = item => {
  bussBar.questionID = item.id
  bussBar.keyword = item.question
  getInnerAnswer()
}
// 切换面板
const changeTab = key => {
  if (key == 'third') {
    getAnswer()
  } else {
    getInnerAnswer()
  }
}
const emit = defineEmits(['exportMessage'])
const exportMessage = answer => {
  emit('exportMessage', answer)
  toggleWindow()
}
// 监听页面滚动事件
function handleScroll({ target }) {
  if (showTips.value) return false
  const DOM = target
  const scrollTop = DOM.scrollTop //滚动条的高度
  if (scrollTop > 500) {
    showTips.value = true
  }
}
onMounted(() => {
  associateListRef.value.addEventListener('scroll', handleScroll)
})
onBeforeUnmount(() => {
  associateListRef.value.removeEventListener('scroll', handleScroll)
})
defineExpose({ closeWindow })
</script>
<style lang="scss" scoped>
.floating-window {
  position: absolute;
  bottom: 280px;
  right: 16px;
  z-index: 999;
  &.fullScreen {
    top: 52px;
    bottom: 217px;
    left: 16px;
    right: 16px;
  }
  .ai-btn {
    width: 60px;
    height: 60px;
    cursor: pointer;
    &.expanded {
      height: 0;
    }
  }
}

.toggle-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
}

.window-content {
  height: 0;
  width: 0;
  overflow: hidden;

  &.expanded {
    width: 570px;
    overflow: initial;
    height: fit-content;
  }
  &.fullScreen {
    width: 100%;
    height: 95%;
    .ai-chat {
      height: calc(100% - 40px);
      .content-wrap {
        height: calc(100% - 105px) !important;
        .content.show {
          height: 100%;
          transition: height 0.3s ease;
        }
      }
    }
  }
  .header {
    height: 67px;
    background-image: linear-gradient(87deg, #5cb2fd 4%, #b1e2ff 59%, #71aff7 99%);
    border-radius: 12px;
    width: 100%;
    padding: 0 16px 27px 20px;
    .ai {
      width: 60px;
      margin-top: -20px;
      margin-right: 5px;
    }
    .logo {
      width: 67px;
      height: 23px;
    }
    .expend {
      width: 16px;
      margin-right: 24px;
      cursor: pointer;
    }
    .close {
      width: 20px;
      cursor: pointer;
    }
    .handler-icon {
      text-align: right;
      line-height: 40px;
    }
  }
  .ai-chat {
    margin-top: -27px;
    width: 100%;
    border-radius: 12px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    overflow: hidden;
    .search-header {
      padding: 16px;
      padding-bottom: 0px;
      .depart {
        margin-bottom: 14px;
      }
      .ai-search {
        margin-bottom: 9px;
        ::v-deep(.ant-input-affix-wrapper-lg) {
          padding: 9px 10px;
          border-radius: 8px 0 0 8px;
          border: 2px solid #35c3ff;
          line-height: initial;
          // border-image: linear-gradient(to right, #8f41e9, #578aef) 1;
          .ant-input.ant-input-lg {
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            &::placeholder {
              font-weight: 400;
            }
          }
          .ant-input-affix-wrapper-focused {
            outline: none;
            box-shadow: initial;
          }
          .ant-input-suffix .ant-input-clear-icon {
            font-size: 17px;
          }
        }
        ::v-deep(.ant-input-group-addon .ant-btn) {
          padding: 11px 20px;
          line-height: 22px;
          height: fit-content;
          border: none;
          background-image: linear-gradient(180deg, #35c3ff 0%, #1890ff 100%);
          border-radius: 0 8px 8px 0;
          border-radius: 0 8px 8px 0;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
    .content-wrap {
      height: 281px;
      // height: fit-content;
      padding-bottom: 7px;
      background: #ffffff;
      position: relative;
      &::-webkit-scrollbar {
        width: 4px;
      }
      .tips {
        background-color: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 0 28px 8px;
        font-weight: 400;
        font-size: 12px;
        color: #ff8c00;
        line-height: 17px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 6px;
        }
      }
      .content {
        height: 0px;
        &.show {
          transition: height 0.3s ease;
          will-change: height;
          height: 274px;
        }
      }
      .search-content {
        overflow: auto;
        // height: 100%;
        // position: relative;

        &.showPadding {
          padding-top: 36px;
        }
        .item {
          cursor: pointer;
          padding: 7px 28px;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 22px;

          &:hover {
            background: #f4f6f8;
            color: #1890ff;
            ::v-deep(span) {
              color: #1890ff !important;
            }
          }
        }
      }

      .answer-wrap {
        .category {
          height: 100%;
          ::v-deep(.ant-tabs-nav-container) {
            margin-bottom: 0;
          }
          ::v-deep(.ant-tabs-ink-bar) {
            // width: 23px !important;
            // left: 50% !important;
            // transform: translateX(-50%) !important;
          }
          ::v-deep(.ant-tabs-bar) {
            margin: 0 16px;
          }

          ::v-deep(.ant-tabs-tab) {
            margin-right: 24px;
            padding: 0 0 6px;
            line-height: 30px;
          }

          ::v-deep(.ant-tabs-content) {
            height: calc(100% - 26px);
          }
          ::v-deep(.ant-tabs-tab:first-child) {
            margin-left: initial;
          }

          ::v-deep(.ant-tabs-tabpane) {
            background: #ffffff;
            height: 100%;
            overflow: hidden;
          }
          ::v-deep(.ant-tabs-nav-wrap) {
            background-color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
